(() => {
  'use strict';
  function setup() {
    document.querySelectorAll('[data-accessory-hub]').forEach(hub => {
      if (hub.dataset.accessoryReady) return;
      const copy = JSON.parse(hub.querySelector('[data-accessory-copy]').textContent);
      const products = Array.from(hub.querySelectorAll('[data-accessory-product]'));
      const links = Array.from(hub.querySelectorAll('[data-accessory-filter]'));
      const heading = hub.querySelector('[data-accessory-heading]');
      const count = hub.querySelector('[data-accessory-results]');
      const help = hub.querySelector('[data-accessory-help]');
      const related = hub.querySelector('[data-accessory-related]');
      const guide = hub.querySelector('.ap-guide');
      const filterFromHash = () => {
        const key = location.hash.replace(/^#accessory-/, '');
        return Object.prototype.hasOwnProperty.call(copy, key) && typeof copy[key] === 'object' ? key : 'all';
      };
      function filter(key, focus = false) {
        if (!copy[key] || typeof copy[key] !== 'object') key = 'all';
        let shown = 0;
        products.forEach(product => {
          const visible = key === 'all' || product.dataset.category === key;
          product.hidden = !visible;
          if (visible) shown++;
        });
        links.forEach(link => link.setAttribute('aria-current', String(link.dataset.accessoryFilter === key)));
        heading.textContent = copy[key].label;
        count.textContent = `${shown} ${copy.products}`;
        help.textContent = copy[key].help;
        related.hidden = key !== 'all';
        guide.open = key !== 'all';
        hub.dataset.selectedCategory = key;
        if (focus) hub.querySelector('#AccessoryProducts').focus({ preventScroll: true });
      }
      hub.querySelectorAll('[data-accessory-count]').forEach(element => {
        element.textContent = `${products.filter(product => product.dataset.category === element.dataset.accessoryCount).length} ${copy.models}`;
      });
      links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const key = link.dataset.accessoryFilter;
        history.pushState(null, '', `#accessory-${key}`);
        filter(key, false);
      }));
      window.addEventListener('hashchange', () => filter(filterFromHash()));
      window.addEventListener('popstate', () => filter(filterFromHash()));
      products.forEach(product => {
        const input = product.querySelector('[data-accessory-quantity]');
        const link = product.querySelector('[data-accessory-quote]');
        if (!input || !link) return;
        const update = () => {
          const raw = Math.floor(Number(input.value));
          const quantity = Number.isSafeInteger(raw) && raw > 0 ? String(raw) : '1';
          const url = new URL(link.href, location.origin);
          url.searchParams.set('uq_quantity', quantity);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
          link.href = url.href;
        };
        ['input','change'].forEach(event => input.addEventListener(event, update));
        ['click','auxclick','contextmenu','pointerdown','focus'].forEach(event => link.addEventListener(event, update));
        update();
      });
      hub.dataset.accessoryReady = 'true';
      filter(filterFromHash());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
